import React from 'react';
import { createPortal } from 'react-dom';

const Modal = ({ 
  isOpen, 
  onClose, 
  children, 
  className = '', 
  overlayClassName = '' 
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const modalContent = (
    <div 
      className={`modal-overlay ${overlayClassName}`}
      onClick={handleOverlayClick}
    >
      <div 
        className={`modal ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );

  // Render modal as a portal to document.body
  return createPortal(modalContent, document.body);
};

export default Modal; 